var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPagearrowrightdouble(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.638 6.889a1.267 1.267 0 000-1.777L5.965.368a1.23 1.23 0 00-1.754 0 1.267 1.267 0 000 1.78L6.77 4.742H1.24c-.329 0-.648.133-.88.368-.232.236-.36.556-.36.89 0 .333.128.653.36.888.232.236.551.369.88.369h5.53L4.21 9.853a1.259 1.259 0 00-.363.89 1.274 1.274 0 00.363.889 1.239 1.239 0 00.877.368 1.224 1.224 0 00.877-.368l4.673-4.743z",
    fill: "#2A848E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.79 6.889a1.267 1.267 0 000-1.777L11.115.368a1.23 1.23 0 00-1.753 0 1.267 1.267 0 000 1.78l2.558 2.595.23.257c.238.36.231.388 0 0 .152.255.5.667.5 1 0 .333-.151.5-.366.889 0 0 .17-.199-.133.111l-.231.258-2.558 2.595a1.26 1.26 0 00-.363.89 1.274 1.274 0 00.363.889 1.239 1.239 0 00.877.368 1.224 1.224 0 00.876-.368l4.673-4.743z",
    fill: "#2A848E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagearrowrightdouble);
export default ForwardRef;